import styled from 'styled-components';

import { ReactComponent as TaskIcon } from '../../../assets/icons/v2/clipboard-add.svg';
import Button from '../../../components/Button';
import colors from '../../../styles/colors';

const circleIconPx = 30;

// Circle icon button, matching the sibling actions on UserProfileCard / the feed header.
const CircleIconButton = styled(Button)`
  background-color: transparent;
  color: ${colors.shades.secondary3};
  border-radius: 50%;
  width: ${circleIconPx}px;
  height: ${circleIconPx}px;
  padding: 8px;
  margin-left: 2px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.shades.gamma1};
  }
`;

// clipboard-add.svg is an ink stroke-based v2 line icon (#24352F stroke), so it matches the
// surrounding actions without recolouring; the clipboard silhouette reads as a task and is
// distinct from the document-style `notes` icon next to it.
const CircleTaskIcon = styled(TaskIcon)`
  height: 18px;
  width: 18px;
`;

const PillTaskIcon = styled(TaskIcon)`
  height: 15px;
  width: 15px;
`;

export {
  CircleIconButton,
  CircleTaskIcon,
  PillTaskIcon,
};
